import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from '../../../Context/Context';
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { SwitchDivs } from "../../../functionalities/Switch";
import { HideCuota } from "../../../functionalities/HideCuota";

function mergeCuota12(cuotas) {
    if (!Array.isArray(cuotas)) return cuotas;

    const tieneCuota12 = cuotas.some(
        c => Number(c.cuota_desde) === 12 && Number(c.cuota_hasta) === 12
    );
    if (!tieneCuota12) return cuotas;

    return cuotas
        .filter(c => !(Number(c.cuota_desde) === 12 && Number(c.cuota_hasta) === 12))
        .map(c =>
            Number(c.cuota_hasta) === 11 ? { ...c, cuota_hasta: "12" } : c
        );
}

/* estilos Material ui accordion */
const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        border: "none"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    }
}));

export const Planes = ({ planes, vehiculo, id, handleSubscription }) => {
    const [state, setState] = useContext(AppContext);
    const [expand, setexpand] = useState(false);
    const [subscriptionButton, setSubscriptionButton] = useState({
        botonSuscripcion: 'Subscribe', // Default button text
        URLSuscripcion: '#',           // Default URL
        suscripcionHabilitada: false   // Default disabled state
    });



    const classes = useStyles();

    let planesToShow = [];
    if (planes.length !== 0) {
        planes.map(plan => {
            planesToShow.push(plan);
        });
    }

    function formatNumber(value) {
        let number = Number(value).toFixed(2);
        let [integerPart, decimalPart] = number.split('.');

        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return `${integerPart},${decimalPart}`;
    }

    console.log(planesToShow);

    useEffect(() => {
        setexpand(true);
    }, [id]);

    useEffect(() => {
        new SwitchDivs(".planesContainer", ".containerSwitch");
        var cuota = document.querySelector(".primer-cuota");
        var button = document.querySelector("#button-accordion");

        if ((button, cuota)) {
            new HideCuota("#button-accordion", ".primer-cuota");
        }

        if (expand) {
            cuota.classList.add("cuota--hide");
        } else {
            cuota.classList.remove("cuota--hide");
        }
    });



    useEffect(() => {
        fetch("/get_subscription_button")
            .then(res => res.json())
            .then(data => {
                setSubscriptionButton(data);
            });
    }, []);

    function redirectToSubscription(plan) {
        const baseUrl = subscriptionButton.URLSuscripcion;
        const params = new URLSearchParams({
            Modelo: vehiculo.id_api.replace(/\s+/g, ''),
            PlanCC: plan.id_plan.substring(1),
            ModeloDesc: vehiculo.titulo + " " + vehiculo.subtitulo,
            PlanDesc: plan.titulo + " " + plan.tipo
        });
        const url = `${baseUrl}/?${params.toString()}`;
        window.open(url, '_blank');
    }


    let handleExpanded = () => {
        setexpand(!expand);
    };

    const firstVisiblePosition = planesToShow
        .map((plan, position) => ({ plan, position }))
        .find(({ plan }) => plan.visible === 1).position;

    return (
        <div className="planesContainer">
            <div className="planesContainer--buttons">
                {planesToShow.map((plan, index) =>
                    plan.visible == 1 ? (
                        <a
                            className={
                                index === firstVisiblePosition
                                    ? "button button--selected"
                                    : "button"
                            }
                            href="#"
                            data-switch={plan.tipo}
                        >
                            <div>{plan.tipo}</div>
                        </a>
                    ) : (
                        <></>
                    )
                )}
            </div>

            <div className="containerSwitch">
                <div className="containerSwitch--items">
                    <div className="drop-container">
                        <div className="drop  drop--planes">
                            {planesToShow.map((plan, index) =>
                                plan.visible == 1 ? (
                                    <div
                                        className={
                                            index === firstVisiblePosition
                                                ? "items show"
                                                : "items"
                                        }
                                        data-switch={plan.tipo}
                                        key={index}
                                    >
                                        {subscriptionButton.suscripcionHabilitada == "1" && (
                                            <button
                                                className="btn-planes"
                                                style={{
                                                    width: "100%"
                                                }}
                                                onClick={() => redirectToSubscription(plan)}
                                            >
                                                {subscriptionButton.botonSuscripcion}
                                            </button>
                                        )}
                                        <div
                                            className="d-flex"
                                            style={{
                                                marginBottom: "24px"
                                            }}
                                        >
                                        </div>


                                        <h1 className="titlePlanes">
                                            {plan.titulo}
                                        </h1>
                                        {(plan.beneficio_1 ||
                                            plan.beneficio_2 ||
                                            plan.beneficio_3 ||
                                            plan.beneficio_4) && (
                                                <>
                                                    <h2>Beneficios:</h2>
                                                    <ul>
                                                        {plan.beneficio_1 && (
                                                            <li>
                                                                {plan.beneficio_1}
                                                            </li>
                                                        )}
                                                        {plan.beneficio_2 && (
                                                            <li>
                                                                {plan.beneficio_2}
                                                            </li>
                                                        )}
                                                        {plan.beneficio_3 && (
                                                            <li>
                                                                {plan.beneficio_3}
                                                            </li>
                                                        )}
                                                        {plan.beneficio_4 && (
                                                            <li>
                                                                {plan.beneficio_4}
                                                            </li>
                                                        )}
                                                    </ul>
                                                </>
                                            )}
                                        <div className={classes.root}>
                                            <Accordion
                                                expanded={expand}
                                                onClick={handleExpanded}
                                            >
                                                <AccordionSummary
                                                    expandIcon={
                                                        <ExpandMoreIcon />
                                                    }
                                                    aria-controls="panel1a-content"
                                                    // id="panel1a-header"
                                                    id="button-accordion"
                                                >
                                                    <Typography
                                                        className={
                                                            classes.heading
                                                        }
                                                        style={{ color: '#EDEDE3' }}
                                                    >
                                                        ESQUEMA DE CUOTAS *
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography
                                                        variant="h1"
                                                        component="div"
                                                        style={{
                                                            width: "100%"
                                                        }}
                                                    >
                                                        {mergeCuota12(plan.cuotas[0]).map(
                                                            cuota => (
                                                                <div className="cuotas">
                                                                    <div>
                                                                        Cuota{" "}
                                                                        {cuota.cuota_desde !==
                                                                            cuota.cuota_hasta
                                                                            ? `${cuota.cuota_desde} a ${cuota.cuota_hasta}`
                                                                            : cuota.cuota_desde}
                                                                    </div>
                                                                    <div>
                                                                        ${" "}{formatNumber(cuota.cuota_importe)}
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}

                                                        <div className="cuotas">
                                                            <div>Alicuota</div>
                                                            <div>
                                                                ${" "}{formatNumber(plan.alicuota)}
                                                            </div>
                                                        </div>
                                                        <div className="cuotas">
                                                            <div>
                                                                Gastos
                                                                administrativos
                                                            </div>
                                                            <div>
                                                                ${" "}{formatNumber(plan.gastos_administrativos)}
                                                            </div>
                                                        </div>
                                                        <div className="cuotas">
                                                            <div>
                                                                Seguro de vida
                                                            </div>
                                                            <div>
                                                                ${" "}{formatNumber(plan.seguro_vida)}
                                                            </div>
                                                        </div>
                                                        <div className="cuotas">
                                                            <div>
                                                                Derecho de
                                                                inscripción{" "}
                                                                <p className="mb-0">
                                                                    {
                                                                        plan.derecho_suscripcion_cuotas
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div>
                                                                ${" "}{formatNumber(plan.derecho_suscripcion)}
                                                            </div>
                                                        </div>
                                                        <div className="cuotas">
                                                            <h1>
                                                                Total valor
                                                                móvil
                                                            </h1>
                                                            <div>
                                                                ${" "}{formatNumber(plan.total_valor_vehiculo)}
                                                            </div>
                                                        </div>
                                                        {state.totalValorNetoEnabled && plan.total_valor_neto != null && (
                                                            <div className="cuotas">
                                                                <h1>
                                                                    Total valor
                                                                    neto
                                                                </h1>
                                                                <div>
                                                                    ${" "}{formatNumber(plan.total_valor_neto)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {plan.legales && (
                                                            <p className="cuotas-p">
                                                                * {plan.legales}
                                                            </p>
                                                        )}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                            <div className="cuotas mt-octa primer-cuota">
                                                <div className="ff-14">
                                                    Cuota 1
                                                </div>
                                                <div>
                                                    ${" "}
                                                    {Number(
                                                        plan.cuotas[0][0]
                                                            .cuota_importe
                                                    ).toLocaleString("de-De")}
                                                </div>
                                            </div>
                                            <div className="separator--hor mt-half mb-octa"></div>
                                        </div>
                                        <div className="separator--hor separator--hor--gris my-half mb-octa display"></div>
                                        <Link
                                            to={"/mas_informacion_plan"}
                                            className="legalesPlan"
                                        >
                                            Más información<img src="/images/icons/arrow-right-white.svg" />
                                        </Link>
                                    </div>
                                ) : (
                                    <></>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
